import {LeafletEventHandlerFnMap} from "leaflet";
import {useMapEvents} from "react-leaflet";

export const MapEventHandler = ({click}: LeafletEventHandlerFnMap) => {
    useMapEvents({
        click,
    });
    return null;
};
